<div
  class="calendar-container"
  (window:resize)="onResize()"
  >
  @if (calendarConfig) {
    <div class="calendar-layout">
      <!-- Sidebar -->
      <div class="calendar-sidebar">
        <div class="sidebar-content">
          <p-datepicker
            [(ngModel)]="selectedDate"
            [inline]="true"
            [minDate]="minDate"
            [maxDate]="maxDate"
            [disabledDays]="disabledDays"
            [showOtherMonths]="true"
            [selectOtherMonths]="true"
            [fluid]="true"
            class="sidebar-datepicker"
            (onSelect)="onSelect($event)"
          />
          <app-appointment-card
            [toConfirmBookingSlots]="toConfirmBookingSlots"
            [currentDoctor]="currentDoctor"
            [doctorBookingTypes]="doctorBookingTypes"
            [totalCount]="totalCountToConfirm"
            [currentPage]="currentPageToConfirm"
            [totalPages]="totalPagesToConfirm"
            [loading]="loadingPageToConfirm"
            (onConfirm)="confirmBookingSlot($event)"
            (onCancel)="cancelBookingSlot($event)"
            (onEdit)="editBookingSlot($event)"
            (onPageChange)="getToConfirmBookingSLots($event)"
          ></app-appointment-card>
          <app-appointment-categories-card
            [isPortletCollapse]="isPortletCollapse"
            [arrowDirection]="arrowDirection"
            [doctorBookingTypes]="doctorBookingTypes"
            (onNavigateLink)="navigateToLink($event)"
            (onTogglePortlet)="togglePortlet($event)"
          ></app-appointment-categories-card>
          <!-- Simple settings card -->
          <div class="simple-settings-card">
            <div class="settings-header">
              <i class="fas fa-cog header-icon"></i>
              <h3 class="settings-title">{{ "connect.calendar.settings" | translate }}</h3>
            </div>
            <div class="settings-content">
              <!-- Intervals -->
              <div class="settings-row">
                <app-custom-select
                  [label]="'connect.calendar.intervals' | translate"
                  [placeholder]="'connect.calendar.select_option' | translate"
                  [options]="timeIntervalOptions"
                  [value]="currentDoctor?.average_time_interval?.toString()"
                  (selectionChange)="changeSlotDuration($event)"
                ></app-custom-select>
              </div>
              <!-- Time Range -->
              <div class="settings-row">
                <div class="time-range-section">
                  <h4 class="time-range-title">{{ "connect.calendar.set_time" | translate }}</h4>
                  <div class="time-inputs-row">
                    <app-custom-select
                      [label]="'connect.calendar.start_time' | translate"
                      [options]="startTimeOptions"
                      [value]="(currentDoctor?.opening_hour ?? minTime)?.toString()"
                      (selectionChange)="onStartTimeChange($event)"
                      size="sm"
                    ></app-custom-select>
                    <div class="time-separator">
                      <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 -960 960 960" width="16px" fill="#111"><path d="m560-240-56-58 142-142H160v-80h486L504-662l56-58 240 240-240 240Z"/></svg>
                    </div>
                    <app-custom-select
                      [label]="'connect.calendar.end_time' | translate"
                      [options]="endTimeOptions"
                      [value]="(currentDoctor?.closing_hour ?? maxTime)?.toString()"
                      (selectionChange)="onEndTimeChange($event)"
                      size="sm"
                    ></app-custom-select>
                  </div>
                  <div class="save-button-row">
                    <app-custom-button
                      variant="primary"
                      [fullWidth]="true"
                      (clicked)="saveAllSettings()"
                      [disabled]="isClicked"
                      >
                      @if (isClicked) {
                        <span style="display: flex; justify-content: center;">
                          <span>{{ "connect.calendar.save" | translate }} </span>
                          <svg viewBox="0 0 50 50" style="width: 20px; height: 20px; animation: spin 1s linear infinite;">
                            <circle cx="25" cy="25" r="20" fill="none" stroke="currentColor" stroke-width="5" stroke-dasharray="31.4" />
                          </svg>
                        </span>
                      } @else {
                        <span>{{ "connect.calendar.save" | translate }}</span>
                      }
                    </app-custom-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Main Calendar -->
      <div class="calendar-main">
        <div class="kt-portlet booking-calendar" id="kt_portlet">
          <div class="kt-portlet__body">
            <app-loading-badge
              [active]="calendarLoading"
              textKey="connect.calendar.loading_bookings"
              ariaLabelKey="connect.calendar.loading_bookings"
              [autoHideAfterMs]="15000"
              (autoHide)="calendarLoading = false"
            ></app-loading-badge>
            <full-calendar
              #calendar
              schedulerLicenseKey="CC-Attribution-NonCommercial-NoDerivatives"
              [options]="calendarConfig"
              >
            </full-calendar>
          </div>
        </div>
      </div>
    </div>
  }
</div>
